import { render } from "./SellerStyleTwo.vue?vue&type=template&id=2b338f33"
import script from "./SellerStyleTwo.vue?vue&type=script&lang=js"
export * from "./SellerStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__